import React, { useEffect, useState } from 'react';
import { getFirestore, collection, query, where, orderBy, onSnapshot, deleteDoc, doc } from "firebase/firestore";
import { auth } from './firebaseConfig';

const db = getFirestore();

function IdeasList() {
  const [ideas, setIdeas] = useState([]);

  useEffect(() => {
    if (!auth.currentUser) return;

    const q = query(
      collection(db, "ideas"),
      where("userId", "==", auth.currentUser.uid),
      orderBy("createdAt", "desc")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const ideasData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      setIdeas(ideasData);
    });

    return () => unsubscribe();
  }, []);

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "ideas", id));
    } catch (error) {
      alert("Error deleting idea: " + error.message);
    }
  };

  return (
    <div style={{ marginTop: '20px' }}>
      <h2 style={{ marginBottom: '10px' }}>💡 Your Ideas</h2>
      {ideas.length === 0 && <p style={{ color: '#666' }}>No ideas yet. Add one above!</p>}
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {ideas.map((idea) => {
          const createdAt = idea.createdAt?.toDate?.() || null;
          return (
            <div
              key={idea.id}
              style={{
                padding: '12px 16px',
                borderRadius: '8px',
                backgroundColor: '#f9fafb',
                border: '1px solid #e0e0e0',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
              }}
            >
              <div>
                <div style={{ fontWeight: 600, color: '#333' }}>{idea.text}</div>
                <div style={{ fontSize: '12px', color: '#888' }}>
                  {createdAt ? createdAt.toLocaleString() : 'No date'}
                </div>
              </div>

              <button
                onClick={() => handleDelete(idea.id)}
                style={{
                  backgroundColor: '#ff6b6b',
                  color: '#fff',
                  border: 'none',
                  padding: '6px 10px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  transition: '0.2s',
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#e63946'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#ff6b6b'}
              >
                Delete
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default IdeasList;
